//import Vue from 'vue'
import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
//import './registerServiceWorker'


createApp(App).use(router).use(store).mount('#app')
